import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  withCredentials: false
});

/**
 * Sign up a new user
 * Backend creates user in Firebase Auth and Firestore, returns JWT tokens
 */
export async function signup(email, password, firstName, lastName) {
  try {
    const { data } = await api.post("/api/auth/signup", {
      email,
      password,
      firstName,
      lastName
    });
    return data?.data || data;
  } catch (error) {
    console.error("Signup API error:", error);
    throw error;
  }
}

/**
 * Sign in an existing user
 * Backend verifies user in Firebase Auth and Firestore, returns JWT tokens
 */
export async function signin(email, password) {
  try {
    const { data } = await api.post("/api/auth/signin", {
      email,
      password
    });
    return data?.data || data;
  } catch (error) {
    console.error("Signin API error:", error);
    throw error;
  }
}

/**
 * Exchange Firebase ID token for custom JWT (Deprecated - use signup/signin instead)
 */
export async function exchangeFirebaseIdToken(idToken) {
  const { data } = await api.post("/api/auth/firebase", { idToken });
  // expected { success, data: { user, accessToken, refreshToken, expiresIn } }
  return data?.data || data;
}

export function persistSession(session) {
  if (!session) return;
  const { accessToken, refreshToken, user } = session;
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("token", accessToken); // keep legacy key for existing code
  }
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
    if (user.id) localStorage.setItem("userId", user.id);
  }
}

export function clearSession() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
}


